<!-- src/app/common/portal/portal-overlay.component.html -->
@if (isOpen) {
  <div class="backdrop" (click)="close()"></div>

  <div class="panel" role="dialog">
    <iframe
      class="portal-frame"
      [src]="portalSrc"
      sandbox="allow-scripts allow-forms allow-same-origin"
      referrerpolicy="no-referrer"
    ></iframe>

    <!-- Iframe-address breadcrumb. Matches the top-right corner where the
         install-crumb sits in the underlying shell so the participant has
         continuous awareness of "which host am I looking at right now." -->
    @if (addressLabel) {
      <div class="portal-address" [title]="activeUrl ?? ''">
        <span class="address-dot"></span>
        <span class="address-text">{{ addressLabel }}</span>
      </div>
    }

    <button class="portal-close" (click)="close()">
      <span class="close-icon">&times;</span>
      <span class="close-label">{{ 'portal.back' | t }}</span>
    </button>
  </div>
}
